import { createContext } from '@chakra-ui/react-utils';
import { usePhoneInput } from 'react-international-phone';

type PhoneInputContext = ReturnType<typeof usePhoneInput> & {
  inputWidth: number;
  stateProps: {
    isDisabled?: boolean;
    isInvalid?: boolean;
    isReadOnly?: boolean;
  };
};

export const [PhoneInputProvider, usePhoneInputContext] =
  createContext<PhoneInputContext>({
    name: 'PhoneInputContext',
    errorMessage:
      'usePhoneInputContext: `context` is undefined. Seems you forgot to wrap all menu components within `<PhoneInput />`',
  });
